// The original "اعرف اكثر عن لوحاتنا الفنية" questions. Shown on the product page
// until FAQs are added from the dashboard, which can also import this list.
const DEFAULT_FAQS = [
  {
    question: "ما نوع الخامات المستخدمة",
    answer: "نستخدم قماش كانفس عالي الجودة، وأحبار طباعة مقاومة للأشعة فوق البنفسجية لضمان بقاء الألوان ثابتة لفترة طويلة",
  },
  {
    question: "هل اللوحات جاهزة للتعليق",
    answer: "نعم، جميع اللوحات تأتي مشدودة على إطار خشبي جاهز للتعليق مباشرة على الجدار",
  },
  {
    question: "كم يستغرق تجهيز الطلب وتوصيله",
    answer: "عادةً يستغرق تجهيز الطلب من 2 إلى 5 أيام عمل، والتوصيل يعتمد على موقعك، لكن غالبًا خلال 3 إلى 7 أيام عمل",
  },
  {
    question: "ماذا لو وصلتني اللوحة وبها تلف",
    answer: "نحرص على تغليف اللوحات بعناية، لكن في حال وجود أي تلف، نرجو التواصل معنا خلال 48 ساعة من استلام الطلب مع صور توضح المشكلة، وسنقوم باستبدال المنتج",
  },
  {
    question: "كيف أختار المقاس المناسب للوحة",
    answer: "لوحات مفردة صغيرة (مثل 30×40 سم أو 40×60 سم): مناسبة للمساحات الصغيرة مثل فوق الطاولات الجانبية أو في الزوايا. لوحات متوسطة (مثل 60×90 سم أو 70×100 سم): مثالية لوضعها فوق الكنب، السرير أو في الممرات.",
  },
];

export default DEFAULT_FAQS;
